module.exports = __webpack_public_path__ + "media/images/home-m-1-9a1d634f0b68058376cc9c66a6fb12cc.jpg";